'use client';

import '@mantine/core/styles.css';
import '@mantine/tiptap/styles.css';
import type { ReactNode } from 'react';
import { MantineProvider } from '@mantine/core';
import { publicCssVariables, publicTheme } from '../theme/publicTheme';

const rootCssVariables = `:root { ${Object.entries(publicCssVariables)
  .map(([key, value]) => `${key}: ${value};`)
  .join(' ')} }`;

export function Providers({ children }: { children: ReactNode }) {
  return (
    <MantineProvider theme={publicTheme}>
      <style>{rootCssVariables}</style>
      {children}
    </MantineProvider>
  );
}
